import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  EventEmitter,
  Output,
  ViewChild
} from '@angular/core';
import { Unsubscriber } from 'src/shared/components/unsubscriber/unsubscriber.component';
import { AlertsService } from 'src/shared/services/alerts.service';
import { ErrorLibService } from 'src/shared/services/error-lib.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  Alert,
  EventModel,
  GeneratedEvents,
  ServiceOrder,
  ServiceOrderInformation,
  User,
} from '../../models/alerts.model';
import { MatOption } from '@angular/material/core';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import Swal from 'sweetalert2';
import { ServiceOrderService } from 'src/shared/services/service-order.service';

// Imports Standalone
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatAccordion, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanel } from "@angular/material/expansion";
import { MatDivider } from "@angular/material/divider";
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
@Component({
  selector: 'app-alert-edit',
  templateUrl: './alert-edit.component.html',
  styleUrls: ['./alert-edit.component.less'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatSpinner,
    MatProgressBar,
    MatAccordion,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatExpansionPanel,
    MatSelectModule,
    MatDivider,
    DialogModule,
    FormsModule,
    TableModule,
    ButtonModule,
    CardModule,
    FileUploadModule,
    TagModule,
    TranslateModule,
  ]
})
export class AlertEditComponent
  extends Unsubscriber
  implements OnChanges, OnInit {
  constructor(
    private alertsService: AlertsService,
    private serviceOrderService: ServiceOrderService,
    private errorLibSerivce: ErrorLibService,
    private formBuilder: FormBuilder,
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['editedAlertId']) {
      this.getEditedAlertInformation(changes['editedAlertId'].currentValue);
    }
  }

  ngOnInit(): void {
    this.alertsService.getServiceOrder(null).subscribe();
    this.loadingSelectedOsInformation = true;
    this.subscriptions = this.alertsService
      .getServiceOrderOnAlertInformation(this.editedAlert)
      .valueChanges.subscribe({
        next: (res: any) => {
          if (res?.data?.serviceOrder.count > 0) {
            this.alertHasServiceOrder = true;
            let resObject = res?.data?.serviceOrder?.edges[0]?.node;
            this.selectedOsInformation = new ServiceOrderInformation(
              resObject?.id,
              resObject?.createdAt,
              resObject?.username,
              resObject?.installationReference,
              resObject?.reference,
              resObject?.chAlertId,
              resObject?.status,
              new User(resObject?.assignee?.id, resObject?.assignee?.username),
            );
          }
          this.loadingSelectedOsInformation = false;
        },
        error: (err: any) => {
          this.errorLibSerivce.errorAlert(err);
          this.loadingSelectedOsInformation = false;
        },
      });
  }

  @ViewChild('matRef') matRef: MatSelect;
  @Input() editedAlert: any;
  @Input() changeAlertId: string[];
  @Input() editedInstallation: any;
  @Output() editCancelation = new EventEmitter<boolean>();
  @Output() editAlert = new EventEmitter<boolean>();

  public loadingAlertData$ = this.alertsService.loadingAlertData$;
  public serviceOrdersLoading$ = this.alertsService.serviceOrdersLoading$;
  public serviceOrders$ = this.alertsService.serviceOrders$;
  public selectedOsInformation: ServiceOrderInformation | null = null;
  public loadingSelectedOsInformation: boolean = false;
  public alertHasServiceOrder: boolean = false;
  public generatedEvents: GeneratedEvents;
  public filter: boolean = true;
  public userList: User[] = [];
  public isLoadingAssignee: boolean = false;
  public isLoadingCreateServiceOrder: boolean = false;

  // Armazena os dados do formulário de Criação de Ordem de Serviço
  public serviceOrderForm: FormGroup = this.formBuilder.group({
    priority: [null, [Validators.required]],
    status: [null, [Validators.required]],
    reference: [null, [Validators.required]],
    installation: [null],
    searchAssignee: [null],
    assignee: [null]
  });

  public filterBox(): void {
    this.filter = !this.filter;
  }

  public cancelEdit(): void {
    this.editCancelation.emit(true);
  }

  public createServiceOrder(): void {
    this.isLoadingCreateServiceOrder = true;
    if (this.serviceOrderForm.valid) {
      this.subscriptions = this.alertsService
        .createServiceOrder(
          this.serviceOrderForm.get('reference')?.value,
          this.serviceOrderForm.get('assignee')?.value,
          this.editedAlert.id,
          this.editedAlert.installation.id,
          this.editedAlert.installation.reference,
          this.serviceOrderForm.get('status')?.value,
          this.serviceOrderForm.get('priority')?.value,
          this.editedAlert.installation.latitude,
          this.editedAlert.installation.longitude,
          this.editedAlert.installation.deviceMac,
        )
        .subscribe({
          next: () => {
            this.isLoadingCreateServiceOrder = false;

            Swal.fire({
              title: 'Sucesso!',
              text: 'OS criada com sucesso',
              icon: 'success',
              confirmButtonText: 'Ok',
            });
          },
          error: (err: any) => {
            this.errorLibSerivce.errorAlert(err);
            this.isLoadingCreateServiceOrder = false;
          },
        });
    } else {
      Swal.fire({
        title: 'Erro!',
        text: 'Preencha o formulário.',
        icon: 'error',
        confirmButtonText: 'Ok',
      });
      this.isLoadingCreateServiceOrder = false;
    }
  }

  // Busca os usuários
  public searchAssignee(reference: any) {
    this.isLoadingAssignee = true;
    this.subscriptions = this.serviceOrderService
      .getUsers(reference)
      .valueChanges.subscribe({
        next: (res: any) => {
          this.isLoadingAssignee = false;
          res?.data?.user?.edges.forEach((user: any) => {
            this.userList.push(new User(user.node.id, user.node.username));
          });
        }, error: (error: any) => {
          this.errorLibSerivce.errorAlert(error);
        }
      });
  }

  // Filtra as ordens de serviço por referência
  public filterServiceOrderByReference(reference: any): void {
    this.alertsService.getServiceOrder(reference).
      subscribe({
        next: ((res: any) => {
          this.selectedOsInformation = new ServiceOrderInformation(
            res?.id,
            res?.createdAt,
            res?.user?.username,
            res?.installationReference,
            res?.reference,
            res?.chAlertId,
            res?.status,
            new User(res?.assignee?.id, res?.assignee?.username),
          );
        })
      })
  }

  public getEditedAlertInformation(editedAlertId: string): void {
    this.subscriptions = this.alertsService
      .getAlertById(editedAlertId)
      .subscribe({
        next: (res: any) => {
          let eventList: EventModel[] = [];
          this.editedInstallation = res?.data?.node?.installation?.id;
          this.editedAlert = new Alert(
            res?.data?.node?.firstAlertDatetime,
            res?.data?.node?.installationReference,
            res?.data?.node?.status,
            res?.data?.node?.alertDescription,
          );
          res?.data?.node?.generatedEvents.forEach((event: any) => {
            Object.keys(event.properties).forEach((eventProp: any, i) => {
              eventList.push(
                new EventModel(eventProp, Object.values(event.properties)[i]),
              );
            });
          });

          if (res?.data?.node?.alertRule) {
            this.generatedEvents = new GeneratedEvents(
              res?.data?.node?.alertRule?.name,
              eventList,
            );
          }
        },
        error: (err: any) => {
          this.errorLibSerivce.errorAlert(err);
        },
      });
  }

  public setSelectedOsInformation(selectedSo: ServiceOrder | any): void {
    this.selectedOsInformation = null;
    this.loadingSelectedOsInformation = true;
    this.subscriptions = this.alertsService
      .getServiceOrderInformation(selectedSo.reference)
      .valueChanges.subscribe({
        next: (res: any) => {
          let resObject = res?.data?.serviceOrder?.edges[0]?.node;
          this.selectedOsInformation = new ServiceOrderInformation(
            resObject?.id,
            resObject?.createdAt,
            resObject?.user?.username,
            resObject?.installationReference,
            resObject?.reference,
            resObject?.chAlertId,
            resObject?.status,
            new User(resObject?.assignee?.id, resObject?.assignee?.username),
          );

          this.loadingSelectedOsInformation = false;
        },
      });
  }

  public clearOsSelection(): void {
    this.matRef.options.forEach((data: MatOption) => {
      if (data.selected) {
        data.deselect();
      }
    });
    this.selectedOsInformation = null;
  }

  public addServiceOrderToAlert(): void {
    if (this.selectedOsInformation) {
      this.subscriptions = this.serviceOrderService
        .linkAlertToOS(
          this.selectedOsInformation?.id,
          this.editedAlert?.id,
        )
        .subscribe({
          next: () => {
            this.alertHasServiceOrder = true;
            Swal.fire({
              title: 'Sucesso!',
              text: 'OS adicionada com sucesso',
              icon: 'success',
              confirmButtonText: 'Ok',
            });
          },
          error: (err: any) => {
            console.log(err);
            this.errorLibSerivce.errorAlert(err);
          },
        });
    } else {
      this.errorLibSerivce.errorAlert('Nenhuma OS selecionada');
    }
  }

  public changeAlertStatus(status: string): void {
    this.subscriptions = this.alertsService
      .changeAlertStatus(this.changeAlertId, status)
      .subscribe({
        next: (res: any) => {
          if (
            res?.data?.alertStatusBulkUpdate &&
            res?.data?.alertStatusBulkUpdate?.errors &&
            res?.data?.alertStatusBulkUpdate?.errors.length > 0
          ) {
            this.errorLibSerivce.errorAlert(
              res?.data?.alertStatusBulkUpdate?.errors[0]?.cause,
            );
            return;
          }
          this.editAlert.emit(true);
          Swal.fire({
            title: 'Sucesso!',
            text: 'Status alterado com sucesso',
            icon: 'success',
            confirmButtonText: 'Ok',
          }).then(() => {
            this.getEditedAlertInformation(this.editedAlert?.id);
          });
        },
      });
  }
}
